export default "__VITE_ASSET__DdhSjIZK__"